import React, { Fragment, useState, useEffect, useMemo } from "react";
import Input from "../../elements/CustomInput";
import Select from "../../elements/CustomSelect";
import { Form, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import { Table } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import DateInput from "../../elements/DateInput";

// Row highlight colors (v2 spec): priority customer colors dominate over
// the insufficient-material red. Keys picked to match the spec's intent.
const ROW_COLORS = {
  newCustomer: { backgroundColor: '#FFE0B2', color: '#5D4037', cursor: 'pointer' },   // light orange
  priority:    { backgroundColor: '#BBDEFB', color: '#0D47A1', cursor: 'pointer' },   // light blue
  insufficient:{ backgroundColor: '#f8d7da', color: '#721c24', cursor: 'pointer' },   // existing light red
  newCustomerWithInsufficient:{ backgroundColor: '#FFE0B2', color: '#be0d1d', cursor: 'pointer' },
};

const ExistingOrdersList = ({
  existingOrderListing,
  totalCount,
  setPaginate,
  paginate,
  listParamState,
  handleFilterChange,
  storeList,
  handleCheckboxClick,
  handleAllCheckboxSelect,
  savedJobNumber,
  selectAll,
  selectedIds,
  isDeletedView
}) => {

  // states declaration
  const [items, setItems] = useState([]);
  const [isMore, setIsMore] = useState([]);

  const navigate = useNavigate();

	// function called to fetch more data, pagination
	const fetchMoreData = () => {
    setTimeout(() => {
      setPaginate(paginate + 10)
    }, 1500)
  }

	// function to check pagination mor to load data or not
  useEffect(() => {
    setItems(existingOrderListing)
		if (_.isEqual(totalCount, existingOrderListing.length)) {
      setIsMore(false)
    } else {
      setIsMore(true)
    }
  }, [existingOrderListing])

  // setting new list data using memo
	const data = useMemo(() => items, [items]);

	// setting store list data using memo
	const storeData = useMemo(() => {
    var stores = [{ value: 0, label: "All" }];
    return stores.concat(storeList);
  }, [storeList])

	// handle quality list data
	const isQualityList = useMemo(() => {
    let qualityList = [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }];
    return qualityList
  }, [storeList])

	// handle quality status list data
	const qualityStatusList = useMemo(() => {
    let qualityStatusData = [{ value: "Open", label: "Open" }, { value: "Closed", label: "Closed" }];
    return qualityStatusData
  }, [storeList])

  //function called to handle job no click
  const handleJobNoClick = (existingOrderValue) => {
    localStorage.setItem('Existing_Orders', JSON.parse(true))
    localStorage.setItem('Existing-Orders-Page', JSON.parse(true))
    localStorage.setItem('quality-JobNum', JSON.stringify(existingOrderValue?.JobNo))
    localStorage.setItem('quality-UnitId', JSON.stringify(existingOrderValue?.UnitId))
    localStorage.setItem('Existing_Orders_value', JSON.stringify(existingOrderValue ? existingOrderValue : null))
    if(isDeletedView){
      navigate(`/place-order/order-confirmation/${existingOrderValue?.ContactInfoId}/${existingOrderValue?.UnitId}/D-${existingOrderValue?.JobNo}`)
      // navigate(`/place-order/order-confirmation/contactInfoId=${existingOrderValue?.ContactInfoId}/unitId=${existingOrderValue?.UnitId}/jobNum=D-${existingOrderValue?.JobNo}`)
    }
    else{
      navigate(`/place-order/order-confirmation/${existingOrderValue?.ContactInfoId}/${existingOrderValue?.UnitId}/${existingOrderValue?.JobNo}`)
      // navigate(`/place-order/order-confirmation/contactInfoId=${existingOrderValue?.ContactInfoId}/unitId=${existingOrderValue?.UnitId}/jobNum=${existingOrderValue?.JobNo}`)
    }
  }

  const formatDateForInput = (date) => {
    if (!date) return '';
    return new Date(date).toISOString().split('T')[0];
  };

  return (
    <Fragment>
      <Table bordered responsive>
      <InfiniteScroll
          dataLength={data.length}
          next={fetchMoreData}
          hasMore={isMore}
          loader={
            <div className="data-loading">
              <img src="https://64.media.tumblr.com/695ce9a82c8974ccbbfc7cad40020c62/tumblr_o9c9rnRZNY1qbmm1co1_1280.gifv" />
              <span>Load More</span>
            </div>
          }
          >
        <thead>
          <tr>
            <th style={{verticalAlign: "top"}}>
              <Form.Group controlId="select-all">
                <Form.Label>Select</Form.Label>
                <Form.Check ids="Select" type="checkbox" onChange={(e)=>handleAllCheckboxSelect(e)} checked={selectAll ? selectAll : false} />
              </Form.Group>
            </th>
            <th>
              <Input label={`Job Number`} ids={`jobNumber`} value={listParamState.jobNumber} handleChange={handleFilterChange} validate={false} />
            </th>
            <th>
              <Input label={`Property Name`} ids={`shipToPropertyName`} value={listParamState.shipToPropertyName} handleChange={handleFilterChange} validate={false} />
            </th>
            <th style={{verticalAlign: "top"}}>
              <Form.Label>Priority</Form.Label>
            </th>
            <th>
              <Input label={`Unit Number`} ids={`unitName`} value={listParamState.unitName} handleChange={handleFilterChange} validate={false} />
            </th>
            {/* <th>
              <Input label={`Ordered Date`} ids={`orderedDate`} value={listParamState.orderedDate} handleChange={handleFilterChange} validate={false} />
            </th> */}
            <th>
              <DateInput label={`Installation Date`} value={formatDateForInput(listParamState.installationDate)} ids={`installationDate`} validate={false} handleChange={handleFilterChange} />
            </th>
            <th>
              <Input label={`Salesperson`} ids={`salesPerson`} value={listParamState.salesPerson} handleChange={handleFilterChange} validate={false} />
            </th>
            <th>
              <Select label={`Store Name`} ids="StoreId" result={storeData} value={listParamState.StoreId} handleChange={handleFilterChange} validate={false} />
            </th>
            <th>
              <Select label={`Processed`} ids="isProcessed" result={isQualityList} value={listParamState.isProcessed} handleChange={handleFilterChange} validate={false} />
            </th>
            <th>
              <Select label={`Is Quality?`} ids="isQuality" result={isQualityList} value={listParamState.isQuality} handleChange={handleFilterChange} validate={false} />
            </th>
            <th>
              <Select label={`Quality Status`} ids="qualityStatus" result={qualityStatusList} value={listParamState.qualityStatus} handleChange={handleFilterChange} validate={false} />
            </th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(data) ? (
            _.map(data, (existingOrderValue, index) => {
              let tmpInstallationDate = _.get(existingOrderValue, "OrderInstallationDate", "")
              let isPastDate = tmpInstallationDate ? new Date(tmpInstallationDate).setHours(0,0,0,0) < new Date().setHours(0,0,0,0) : false;
              const isInsufficientItem = (existingOrderValue.BCStatus !=='released' && existingOrderValue.IsInsufficientItem || (existingOrderValue.BCStatus ==='released' && existingOrderValue.IsInsufficientItem && !isPastDate))
              // const isInsufficientItem = existingOrderValue.IsInsufficientItem

              // Priority-highlighting flags (v2 spec). Priority color wins over
              // the insufficient-material red when both apply.
              const isNewCustomer = existingOrderValue.isNewCustomer === true;
              const priorityNumber = existingOrderValue.priorityNumber;
              const isPriorityCustomer = priorityNumber != null && !isNewCustomer;

              let rowStyle;
              if (isNewCustomer && isInsufficientItem) rowStyle = ROW_COLORS.newCustomerWithInsufficient;
              else if (isNewCustomer) rowStyle = ROW_COLORS.newCustomer;
              else if (isPriorityCustomer) rowStyle = ROW_COLORS.priority;
              else if (isInsufficientItem) rowStyle = ROW_COLORS.insufficient;
              const row = (
                <tr
                  key={index}
                  className={savedJobNumber.includes(existingOrderValue.JobNo) ? 'processed-order' : ''}
                  style={rowStyle}
                >
                  <td>
                    <Form.Group controlId={`checkbox-${index}`}>
                      <Form.Check
                        type="checkbox"
                        onChange={e => handleCheckboxClick(e, existingOrderValue)}
                        checked={selectedIds?.includes(existingOrderValue.JobNo) || false}
                      />
                    </Form.Group>
                  </td>
                  <td>
                    <div className="link" onClick={() => handleJobNoClick(existingOrderValue)}>
                      {_.get(existingOrderValue, "JobNo", "")}
                    </div>
                  </td>
                  <td>{_.get(existingOrderValue, "ShipToPropertyName", "")}</td>
                  <td>
                    {isNewCustomer
                      ? <Badge bg="warning">NEW</Badge>
                      : (priorityNumber != null ? priorityNumber : '')}
                  </td>
                  <td>{_.get(existingOrderValue, "UnitName", "")}</td>
                  {/* <td>{_.get(existingOrderValue, "OrderDate", "")}</td> */}
                  <td>{_.get(existingOrderValue, "OrderInstallationDate", "")}</td>
                  <td>{_.get(existingOrderValue, "SalesPerson", "")}</td>
                  <td>{_.get(existingOrderValue, "Store", "")}</td>
                  <td>{savedJobNumber.includes(existingOrderValue.JobNo) ? 'Yes' : 'No'}</td>
                  <td>{_.get(existingOrderValue, "IsQuality", false) ? 'Yes' : 'No'}</td>
                  <td>{_.get(existingOrderValue, "QualityStatus", "")}</td>
                </tr>
              );

              return isInsufficientItem ? (
                <OverlayTrigger
                  key={existingOrderValue.JobNo}
                  placement="top"
                  overlay={
                    <Tooltip
                      id={`tooltip-${existingOrderValue.JobNo}`}
                      style={{
                        backgroundColor: '#f8d7da',
                        color: '#721c24',
                        border: '1px solid #f5c6cb',
                      }}
                    >
                      Insufficient inventory
                    </Tooltip>
                  }
                >
                  {row}
                </OverlayTrigger>
              ) : (
                row
              );
            })
          ) : (
            <tr>
              <td colSpan={19}>No Data Found</td>
            </tr>
          )}
        </tbody>
        </InfiniteScroll>
      </Table>
    </Fragment>
  )
}

export default ExistingOrdersList;
